<div class="container-fluid task-popup" style="overflow-x: hidden; max-width: 100%; box-sizing: border-box; position: relative;">
  <!-- Loading Overlay -->
  <!-- <div class="task-loading-overlay" *ngIf="formLoading">
  <div class="loading-content">
    <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #3b82f6;"></i>
    <p style="margin-top: 1rem; font-size: 1rem; color: #6b7280; font-weight: 500;">Loading task...</p>
  </div>
</div> -->
<mat-tab-group class="task-tab-group">
  <mat-tab label="Details">
    <div [formGroup]="form1" class="forms w-100 d-block taskbtn">
      <div>
        <div>
          <!-- <span class="col-lg-12">
          <h4>{{formTitle}} <span *ngIf="taskApi?.taskId">{{taskApi.taskId}} &nbsp; - &nbsp;
          {{taskApi.name}}</span></h4>
        </span> -->
        <div class="d-flex justify-content-between my-2">
          <div>
            @if (!isModal) {
              <button mat-button (click)="close()" routerLink="/home"> < Go Home</button>
            }
          </div>
          <div class="d-flex gap-2">
            @if (isModal) {
              <button mat-button type="button" (click)="close()" [mat-dialog-close]="true">Cancel</button>
            }
            <button mat-raised-button color="primary" (click)="formSave(false)">Save</button>
            @if (taskApi?.taskId && taskApi?.taskId>0 && 'clone' !== modalPurpose) {
              <button mat-raised-button color="primary"
                (click)="openTaskForClone()">Sub Task
              +</button>
            }
            @if (taskApi?.taskId && taskApi?.taskId>0) {
              <button mat-raised-button color="primary"
                (click)="openMailTask()">Mail
              Task</button>
            }
          </div>
          <!--<button pButton pi pi-envelope color="primary" class="ml-5" *ngIf="taskApi?.taskId && 'clone' !== modalPurpose && !taskApi?.msgId"
        (click)="openSendMail()">Send Mail</button>-->
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-md-8">

          <div class="task-title-wrapper">
            <div class="task-description-label">
              <span>Task Name</span>
            </div>
            <input type="text" class="task-title-input" formControlName="name" required placeholder="Task Name"
              [class.is-invalid]="form1.get('name').invalid && (form1.get('name').dirty || form1.get('name').touched)">
              @for (validation of validationMessages.name; track validation) {
                <div class="task-title-error">
                  @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                    <div class="error-message"
                      >
                      {{validation.message}}
                    </div>
                  }
                </div>
              }
            </div>

            <!-- Template Selection -->
            <!-- <div class="mb-3" style="margin-top: 1rem;">
            <label class="form-label fw-bold" style="font-size: 12px; margin-bottom: 0.5rem;">Template</label>
            <p-dropdown appendTo="body" [options]="templates" formControlName="templateId" optionLabel="name" optionValue="templateId"
              placeholder="Select Template"  [showClear]="true"
              (onChange)="onTemplateChange($event.value)" styleClass="w-100">
            </p-dropdown>
          </div> -->

          <div class="d-flex align-items-center gap-2" style="margin-top: 0.5rem; margin-bottom: 0.5rem;">
            <p-inputSwitch formControlName="isTemplate"></p-inputSwitch>
            <label class="form-label mb-0" style="font-size: 12px; color: #666;">Template</label>
            @if (form1.get('isTemplate')?.value) {
              <span class="badge bg-info" style="font-size: 10px;">This task is a reusable template</span>
            }
          </div>

          <div class="task-description-wrapper">
            <!-- Add Description Button (shown when no description and editor not open) -->
            @if (!showDescriptionEditor && (!form1.get('description').value || form1.get('description').value.trim() === '' || form1.get('description').value === '<p></p>' || form1.get('description').value === '<p><br></p>')) {
            <div class="task-description-placeholder-wrapper"
              >
              <!-- <div class="task-description-placeholder" (click)="openDescriptionEditor()">
              <i class="pi pi-file task-description-icon"></i>
              <span class="task-description-text">Add description</span>
            </div> -->
            <!-- <button mat-button type="button" class="ai-generate-btn-inline"
            (click)="generateDescriptionWithAI(); $event.stopPropagation()"
            [disabled]="isGeneratingAIText || !form1.get('name')?.value" matTooltip="Write with AI"
            style="margin-left: 12px; padding: 4px 12px; font-size: 12px; color: #6366f1;">
            <i class="pi pi-sparkles" *ngIf="!isGeneratingAIText" style="margin-right: 4px;"></i>
            <i class="pi pi-spin pi-spinner" *ngIf="isGeneratingAIText" style="margin-right: 4px;"></i>
            <span>Write with AI</span>
          </button> -->
        </div>
      }

      <!-- Description Editor (shown when description exists or editor is open) -->
      @if (showDescriptionEditor || (form1.get('description').value && form1.get('description').value.trim() !== '' && form1.get('description').value !== '<p></p>' && form1.get('description').value !== '<p><br></p>')) {
      <div class="task-description-editor"
        >
        <!-- <div class="task-description-label"
        style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
        <span>Description (max. 1000 characters)</span>
        <button mat-icon-button type="button" class="ai-generate-btn" (click)="generateDescriptionWithAI()"
          [disabled]="isGeneratingAIText || !form1.get('name')?.value" matTooltip="Write with AI"
          style="color: #6366f1; padding: 4px;">
          <i class="pi pi-sparkles" *ngIf="!isGeneratingAIText"></i>
          <i class="pi pi-spin pi-spinner" *ngIf="isGeneratingAIText"></i>
        </button>
      </div> -->
      <div class="task-description-label task-description-header">
        <span>Description</span>
        <button type="button" class="description-expand-btn" (click)="openDescriptionFullscreen()">
          <i class="pi pi-window-maximize"></i>
        </button>
      </div>
      @if (!isDescriptionFullscreen) {
<editor formControlName="description" [id]="editorInstanceId + '-description'" [init]="{
																					height: 250,
																					base_url: '/tinymce',
																					suffix: '.min',
																					plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
																																toolbar: 'backcolor | undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
																																menubar: false,
																																statusbar: false
																				}">
        </editor>
      }
      @if (isDescriptionFullscreen) {
        <div class="description-fullscreen-overlay">
          <div class="description-fullscreen-container">
            <div class="description-fullscreen-header">
              <span>Description</span>
              <button type="button" class="description-expand-btn" (click)="closeDescriptionFullscreen()">
                <i class="pi pi-times"></i>
              </button>
            </div>
            <div class="description-fullscreen-body">
													<editor formControlName="description" [id]="editorInstanceId + '-description-fullscreen'" [init]="{
																										height: '100%',
																										base_url: '/tinymce',
																										suffix: '.min',
																										plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
																																				toolbar: 'backcolor | undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
																																				menubar: false,
																																				statusbar: false
																									}">
              </editor>
            </div>
          </div>
        </div>
      }
      <!-- Rewrite with AI button below description editor -->
      <!-- <div style="margin-top: 8px; display: flex; justify-content: flex-end;">
      <button mat-button type="button" class="ai-rewrite-btn"
        (click)="rewriteDescriptionWithAI()"
        [disabled]="isGeneratingAIText || !form1.get('name')?.value"
        matTooltip="Regenerate description with AI using all task details"
        style="color: #6366f1; padding: 4px 12px; font-size: 12px;">
        <i class="pi pi-refresh" *ngIf="!isGeneratingAIText" style="margin-right: 4px;"></i>
        <i class="pi pi-spin pi-spinner" *ngIf="isGeneratingAIText" style="margin-right: 4px;"></i>
        <span>Rewrite with AI</span>
      </button>
    </div> -->
  </div>
}
</div>

<!-- Three Grid Tables Section -->
<div class="task-grid-tables-container mt-3">

  <!-- First Table: Status and Date Things -->
  <table class="task-grid-table">
    <thead>
      <tr>
        <th colspan="2" style="text-align: left; padding: 2px 4px; font-weight: 600; font-size: 10px; background-color: #f5f5f5; border-bottom: 1px solid #ddd;">Status and Dates</th>
      </tr>
    </thead>
    <tbody>
      <!-- Status -->
      <tr class="task-grid-row">
        <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
          <span>Status</span>
        </td>
        <td class="task-grid-value" style="padding: 1px 4px;">
          <p-dropdown appendTo="body" class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Select Status"  dropdownIcon="fa fa-caret-down"
          styleClass="w-100" [style]="{'font-size': '10px'}"></p-dropdown>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </td>
      </tr>

      <!-- Next Action -->
      <tr class="task-grid-row">
        <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
          <span>Next Action</span>
        </td>
        <td class="task-grid-value" style="padding: 1px 4px;">
          <p-dropdown appendTo="body" class="w-100" [options]="nextActions" formControlName="nextAction" optionLabel="name"
            optionValue="value" placeholder="Select Next Action"  dropdownIcon="fa fa-caret-down"
          styleClass="w-100" [style]="{'font-size': '10px'}"></p-dropdown>
          @for (validation of validationMessages.nextAction; track validation) {
            <span>
              @if (form1.get('nextAction').hasError(validation.type) && (form1.get('nextAction').dirty || form1.get('nextAction').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </td>
      </tr>

      <!-- Priority -->
      <tr class="task-grid-row">
        <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
          <span>Priority</span>
        </td>
        <td class="task-grid-value" style="padding: 1px 4px;">
          <p-dropdown appendTo="body" class="w-100" [options]="priorities" formControlName="priority" optionLabel="name"
            optionValue="value" placeholder="Select Priority"  dropdownIcon="fa fa-caret-down"
          styleClass="w-100" [style]="{'font-size': '10px'}"></p-dropdown>
          @for (validation of validationMessages.priority; track validation) {
            <span>
              @if (form1.get('priority').hasError(validation.type) && (form1.get('priority').dirty || form1.get('priority').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </td>
      </tr>
      <!-- Next Follow-Up Date -->
      <tr class="task-grid-row">
        <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
          <span>Next Follow-Up Date</span>
        </td>
        <td class="task-grid-value" style="padding: 1px 4px;">
          <p-calendar appendTo="body" formControlName="dateToFollowup" inputId="dateToFollowup"
            [showIcon]="true" dateFormat="mm/dd/yy"
            placeholder="Select date" styleClass="w-100"
          [inputStyle]="{'padding': '2px 4px', 'font-size': '10px', 'text-align': 'right'}"></p-calendar>
          @for (validation of validationMessages.dateToFollowup; track validation) {
            <span>
              @if (form1.get('dateToFollowup').hasError(validation.type) && (form1.get('dateToFollowup').dirty || form1.get('dateToFollowup').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </td>
      </tr>

      <!-- Due Date -->
      <tr class="task-grid-row">
        <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
          <span>Due Date</span>
        </td>
        <td class="task-grid-value" style="padding: 1px 4px;">
          <p-calendar appendTo="body" formControlName="dateDue" inputId="dateDue"
            [showIcon]="true" dateFormat="mm/dd/yy"
            placeholder="Select date" styleClass="w-100"
          [inputStyle]="{'padding': '2px 4px', 'font-size': '10px', 'text-align': 'right'}"></p-calendar>
          @for (validation of validationMessages.dateDue; track validation) {
            <span>
              @if (form1.get('dateDue').hasError(validation.type) && (form1.get('dateDue').dirty || form1.get('dateDue').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </td>
      </tr>

      <!-- Completed Date -->
      <tr class="task-grid-row">
        <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
          <span>Completed Date</span>
        </td>
        <td class="task-grid-value" style="padding: 1px 4px;">
          <p-calendar appendTo="body" formControlName="dateCompleted" inputId="dateCompleted"
            [showIcon]="true" dateFormat="mm/dd/yy"
            placeholder="Select date" styleClass="w-100"
          [inputStyle]="{'padding': '2px 4px', 'font-size': '10px', 'text-align': 'right'}"></p-calendar>
          @for (validation of validationMessages.dateCompleted; track validation) {
            <span>
              @if (form1.get('dateCompleted').hasError(validation.type) && (form1.get('dateCompleted').dirty || form1.get('dateCompleted').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </td>
      </tr>

      <!-- Estimated Hours -->
      <tr class="task-grid-row">
        <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
          <span>Estimated Hours</span>
        </td>
        <td class="task-grid-value">
          <input type="number" pInputText formControlName="hoursEstToComplete" min="0"
            placeholder="Enter hours" class="w-100"
            style="padding: 2px 4px; border: 1px solid #e2e8f0; border-radius: 3px; font-size: 10px; text-align: right;">
            @for (validation of validationMessages.hoursEstToComplete; track validation) {
              <span>
                @if (form1.get('hoursEstToComplete').hasError(validation.type) && (form1.get('hoursEstToComplete').dirty || form1.get('hoursEstToComplete').touched)) {
                  <small class="p-invalid d-block"
                    >
                    {{validation.message}}
                  </small>
                }
              </span>
            }
          </td>
        </tr>

        <!-- Actual Hours -->
        <tr class="task-grid-row">
          <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
            <span>Actual Hours</span>
          </td>
          <td class="task-grid-value">
            <input type="number" pInputText formControlName="hoursActualToComplete" min="0"
              placeholder="Enter hours" class="w-100"
              style="padding: 2px 4px; border: 1px solid #e2e8f0; border-radius: 3px; font-size: 10px; text-align: right;">
              @for (validation of validationMessages.hoursActualToComplete; track validation) {
                <span>
                  @if (form1.get('hoursActualToComplete').hasError(validation.type) && (form1.get('hoursActualToComplete').dirty || form1.get('hoursActualToComplete').touched)) {
                    <small class="p-invalid d-block"
                      >
                      {{validation.message}}
                    </small>
                  }
                </span>
              }
            </td>
          </tr>


        </tbody>
      </table>

      <!-- Second Table: People and Team Things -->
      <table class="task-grid-table">
        <thead>
          <tr>
            <th colspan="2" style="text-align: left; padding: 2px 4px; font-weight: 600; font-size: 10px; background-color: #f5f5f5; border-bottom: 1px solid #ddd;">People</th>
          </tr>
        </thead>
        <tbody>
          <!-- Assigned To Person -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Assigned To Person</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <app-user-search #assignedToUserSearch (onUserSelected)="onAssignedToUserSeleted($event)"
                (onUserClearedEvent)="onAssignedToUserCleared($event)"
              [selectedUser]="assignedToUser" [showCreateUser]="false" [forSearchBar]="true"></app-user-search>
            </td>
          </tr>

          <!-- Assigned To Team -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Assigned To Team</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <app-team-search (onTeamSelected)="onAssignedToTeamSeleted($event)"
                (onTeamClearedEvent)="onAssignedToTeamCleared($event)"
              [selectedTeam]="assignedToTeam" [showCreateTeam]="false"></app-team-search>
            </td>
          </tr>

          <!-- Requested By -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Requested By</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <app-user-search #requestedByUserSearch (onUserSelected)="onRequestedByUserSeleted($event)"
                (onUserClearedEvent)="onRequestedByUserCleared($event)"
              [selectedUser]="requestedByUser" [showCreateUser]="false" [forSearchBar]="false"></app-user-search>
            </td>
          </tr>

          <!-- Collaborators -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Collaborators</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <div class="task-date-label-wrapper clickable-date-wrapper" (click)="openCollaboratorsDialog()">
                @if (getCollaboratorsSummary()) {
                  <span style="font-size: 10px;">{{getCollaboratorsSummary()}}</span>
                }
                @if (!getCollaboratorsSummary()) {
                  <span class="text-muted" style="font-size: 10px;">Click to add collaborators</span>
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Third Table: Remaining Things (Attributes) -->
      <table class="task-grid-table">
        <thead>
          <tr>
            <th colspan="2" style="text-align: left; padding: 2px 4px; font-weight: 600; font-size: 10px; background-color: #f5f5f5; border-bottom: 1px solid #ddd;">Attributes</th>
          </tr>
        </thead>
        <tbody>
          <!-- Property -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Property</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <app-property-select [taskId]="taskId" [shortTermRentalId]="shortTermRentalId"
              (messageEvent)="onPropertySelected($event)"></app-property-select>
            </td>
          </tr>

          <!-- Reservation -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Reservation</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <div>
                <app-task-reservation-select [taskApi]="taskApi"
                (messageEvent)="onReservationSelected($event)"></app-task-reservation-select>
              </div>
              <div class="text-start">
                @if (!openingReservation?.[selectedReservation?.reservationId] && selectedReservation?.reservationId) {
                  <span (click)="openReservation(selectedReservation,$event)"
                  class="cursor-pointer link-text">View Reservation</span>
                }
                @if (openingReservation?.[selectedReservation?.reservationId]) {
                  <span><i class="pi pi-spinner pi-spin"></i></span>
                }
              </div>
            </td>
          </tr>

          <!-- Parent Task -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Parent Task</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <app-task-search [hideTitle]="true" (onTaskSelected)="onParentTaskSeleted($event)"
                (onTaskClearedEvent)="onParentTaskCleared($event)" [selectedTaskId]="taskApi?.parentTaskId"
              [selectedTask]="selectedParentTask"></app-task-search>
            </td>
          </tr>

          <!-- Visibility -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Visibility</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <p-dropdown appendTo="body" class="w-100" [options]="visibilities" formControlName="visibility"
                optionLabel="name" optionValue="value" placeholder="Select Visibility"
              dropdownIcon="fa fa-caret-down" styleClass="w-100" [style]="{'font-size': '10px'}"></p-dropdown>
              @for (validation of validationMessages.visibility; track validation) {
                <span>
                  @if (form1.get('visibility').hasError(validation.type) && (form1.get('visibility').dirty || form1.get('visibility').touched)) {
                    <small class="p-invalid d-block"
                      >
                      {{validation.message}}
                    </small>
                  }
                </span>
              }
            </td>
          </tr>

          <!-- Event -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Event</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <div class="task-date-label-wrapper clickable-date-wrapper" (click)="openEventDialog()" style="white-space: normal; word-wrap: break-word;">
                @if (getEventSummary()) {
                  <span style="font-size: 10px; display: inline-block; word-wrap: break-word; white-space: normal;">{{getEventSummary()}}</span>
                }
                @if (!getEventSummary()) {
                  <span class="text-muted" style="font-size: 10px;">Click to add event</span>
                }
              </div>
            </td>
          </tr>



          <!-- Categories -->
          @if (taskId) {
            <tr class="task-grid-row">
              <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
                <span>Categories</span>
              </td>
              <td class="task-grid-value" style="padding: 1px 4px;">
                <div class="task-date-label-wrapper clickable-date-wrapper" (click)="openCategoriesDialog()">
                  @if (getCategoriesSummary()) {
                    <span style="font-size: 10px;">{{getCategoriesSummary()}}</span>
                  }
                  @if (!getCategoriesSummary()) {
                    <span class="text-muted" style="font-size: 10px;">Click to add categories</span>
                  }
                </div>
              </td>
            </tr>
          }
          <!-- Tags -->
          @if (taskId) {
            <tr class="task-grid-row">
              <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
                <span>Tags</span>
              </td>
              <td class="task-grid-value" style="padding: 1px 4px;">
                <div class="task-date-label-wrapper clickable-date-wrapper" (click)="openTagsDialog()">
                  @if (getTagsSummary()) {
                    <span style="font-size: 10px;">{{ getTagsSummary() }}</span>
                  }
                  @if (!getTagsSummary()) {
                    <span class="text-muted" style="font-size: 10px;">Click to add tags</span>
                  }
                </div>
              </td>
            </tr>
          }

          <!-- Contact -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Contact</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <div class="task-date-label-wrapper clickable-date-wrapper" (click)="openContactDialog()">
                @if (getContactSummary()) {
                  <span style="font-size: 10px;">{{getContactSummary()}}</span>
                }
                @if (!getContactSummary()) {
                  <span class="text-muted" style="font-size: 10px;">Click to add contact</span>
                }
              </div>
            </td>
          </tr>

          <!-- Files -->
          <tr class="task-grid-row">
            <td class="task-grid-label" style="padding: 1px 4px; font-size: 10px;">
              <span>Files</span>
            </td>
            <td class="task-grid-value" style="padding: 1px 4px;">
              <div class="task-date-label-wrapper clickable-date-wrapper" (click)="openFilesDialog()">
                @if (getFilesSummary()) {
                  <span style="font-size: 10px;">{{getFilesSummary()}}</span>
                }
                @if (!getFilesSummary()) {
                  <span class="text-muted" style="font-size: 10px;">Click to add files</span>
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Old pill-style layout removed - replaced with grid tables above -->
  </div>
  <div class="col-md-4">
    <div>
      @if (taskId) {
        <app-notes-chat [config]="notesChatConfig" [noteSourceId]="taskId" [noteSource]="1">
        </app-notes-chat>
      }
    </div>
  </div>
</div>
</div>
</div>
<!-- Master Column 2  -->
<!--<div class="col-lg-3">
<app-task-summary [task]="this.taskApi"></app-task-summary>
</div>-->

<!-- Add Mini Doc Button (shown when no miniDoc and editor not open) -->
@if (!showMiniDocEditor && (!form1.get('miniDoc').value || form1.get('miniDoc').value.trim() === '' || form1.get('miniDoc').value === '<p></p>' || form1.get('miniDoc').value === '<p><br></p>')) {
<div class="task-description-placeholder-wrapper my-2"
  >
  <div class="task-description-placeholder">
    <i class="pi pi-file task-description-icon"></i>
    <span class="task-description-text" (click)="openMiniDocEditor()" style="cursor: pointer;">Add mini doc</span>
  </div>
</div>
}

<!-- Mini Doc Editor (shown when miniDoc exists or editor is open) -->
@if (showMiniDocEditor || (form1.get('miniDoc').value && form1.get('miniDoc').value.trim() !== '' && form1.get('miniDoc').value !== '<p></p>' && form1.get('miniDoc').value !== '<p><br></p>')) {
<mat-card>
  <mat-card-content>
    <div class="task-description-label"
      style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
      <span>Mini Doc</span>
    </div>
						<editor formControlName="miniDoc" [id]="editorInstanceId + '-miniDoc'" [init]="{
								height: 500,
								base_url: '/tinymce',
								suffix: '.min',
								plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
								toolbar: 'backcolor | undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'
							}">
    </editor>
  </mat-card-content>
</mat-card>
}
</div>
<hr>
  <div class="row">
    <div class="col-lg-12">
      <span class="flex flwx-wrap gap-3">
        <div class="button-group">
          <!-- <button pButton *ngIf="taskId && taskApi" class="btn-delete p-button-outlined p-button-danger"
        (click)="onFormDelete()">Delete</button>-->
      </div>
      @if (isModal) {
        <button mat-button type="button" (click)="close()"
        [mat-dialog-close]="true">Cancel</button>
      }
      @if (!isModal) {
        <button mat-button
        (click)="close()" routerLink="/home">Cancel</button>
      }
      <button mat-raised-button color="primary" (click)="formSave(false)" [class.disabled]="buttonLoading">@if (buttonLoading) {
        <i class="pi pi-spinner pi-spin me-2"></i>
      }Save</button>
      <button mat-raised-button color="primary" (click)="formSave(true)" [class.disabled]="buttonLoading">@if (buttonLoading) {
        <i class="pi pi-spinner pi-spin me-2"></i>
      }Save & Close</button>

    </span>
  </div>
</div>
</mat-tab>
@if (attachedMail) {
  <mat-tab label="Comm">
    <app-inbox [inbox]="attachedMail"></app-inbox>
  </mat-tab>
}
@if (taskId) {
  <mat-tab label="Subtasks">
    <div class="p-3">
      <app-task-list
        [viewControlsFilters]="subtaskFilters"
        [showFilter]="true"
        [showPagination]="true"
        [outlineNewButton]="false">
      </app-task-list>
    </div>
  </mat-tab>
}
<mat-tab label="History">
  <app-audit-list [auditUrl]="'tasks/' + taskId + '/audit'"></app-audit-list>
</mat-tab>
</mat-tab-group>
@if (isModal) {
  <button class="tab-close-button" mat-icon-button (click)="close()" [mat-dialog-close]="true">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
}
</div>

<!-- Event Dialog -->
<ng-template #eventDialogTemplate>
  <div class="event-dialog-container">
    <div class="event-dialog-header">
      <h3>Event Details</h3>
    </div>
    <div class="event-dialog-body" [formGroup]="form1">
      <div class="row">
        <div class="col-lg-4 mb-3">
          <span class="p-float-label w-100">
            <p-calendar appendTo="body" [style]="{'width': '100%'}" formControlName="eventStartDate" inputId="eventStartDate"
              [showIcon]="true" dateFormat="mm/dd/yy"
            styleClass="w-100"></p-calendar>
            <label for="eventStartDate">Start Date</label>
          </span>
          @for (validation of validationMessages.eventStartDate; track validation) {
            <span>
              @if (form1.get('eventStartDate').hasError(validation.type) && (form1.get('eventStartDate').dirty || form1.get('eventStartDate').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div class="col-lg-4 mb-3">
          <span class="p-float-label">
            <p-dropdown appendTo="body" [style]="{'width': '100%'}" dropdownIcon="fa fa-caret-down" [options]="time" formControlName="eventStartTime"
              optionLabel="name" optionValue="value" inputId="eventStartTime"
            placeholder="Select Time"></p-dropdown>
            <label for="eventStartTime">Start Time</label>
          </span>
          @for (validation of validationMessages.eventStartTime; track validation) {
            <span>
              @if (form1.get('eventStartTime').hasError(validation.type) && (form1.get('eventStartTime').dirty || form1.get('eventStartTime').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div class="col-lg-4 mb-3">
          <span class="p-float-label">
            <p-dropdown appendTo="body" [style]="{'width': '100%'}" dropdownIcon="fa fa-caret-down" [options]="timeZones" formControlName="timeZone"
              optionLabel="name" optionValue="value" inputId="timeZone"
            placeholder="Select Time Zone"></p-dropdown>
            <label for="timeZone">Time Zone</label>
          </span>
          @for (validation of validationMessages.timeZone; track validation) {
            <span>
              @if (form1.get('timeZone').hasError(validation.type) && (form1.get('timeZone').dirty || form1.get('timeZone').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 mb-3">
          <span class="p-float-label">
            <p-calendar appendTo="body" [style]="{'width': '100%'}" formControlName="eventEndDate" inputId="eventEndDate"
              [showIcon]="true" dateFormat="mm/dd/yy"
            styleClass="w-100"></p-calendar>
            <label for="eventEndDate">End Date</label>
          </span>
          @for (validation of validationMessages.eventEndDate; track validation) {
            <span>
              @if (form1.get('eventEndDate').hasError(validation.type) && (form1.get('eventEndDate').dirty || form1.get('eventEndDate').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div class="col-lg-4 mb-3">
          <span class="p-float-label">
            <p-dropdown appendTo="body" [style]="{'width': '100%'}" dropdownIcon="fa fa-caret-down" [options]="time" formControlName="eventEndTime"
              optionLabel="name" optionValue="value" inputId="eventEndTime"
            placeholder="Select Time"></p-dropdown>
            <label for="eventEndTime">End Time</label>
          </span>
          @for (validation of validationMessages.eventEndTime; track validation) {
            <span>
              @if (form1.get('eventEndTime').hasError(validation.type) && (form1.get('eventEndTime').dirty || form1.get('eventEndTime').touched)) {
                <small class="p-invalid d-block"
                  >
                  {{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div class="col-lg-4"></div>
      </div>
      <div class="row">
        <div class="col-12 mb-3">
          <span class="p-float-label">
            <input [style]="{'width': '100%'}" formControlName="eventLocation" id="eventLocation" type="text"
              pInputText [readonly]="formReadOnly">
              <label for="eventLocation">Location</label>
            </span>
            @for (validation of validationMessages.eventLocation; track validation) {
              <span>
                @if (form1.get('eventLocation').hasError(validation.type) && (form1.get('eventLocation').dirty || form1.get('eventLocation').touched)) {
                  <small class="p-invalid d-block"
                    >
                    {{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <p-accordion #repeatEventAccordion (onOpen)="repeatEventAccordionOpen = true" (onClose)="repeatEventAccordionOpen = false">
              <p-accordionTab>
                <ng-template pTemplate="header">
                  <div class="flex align-items-center gap-2 w-100">
                    <i [class]="repeatEventAccordionOpen ? 'pi pi-minus-circle' : 'pi pi-plus-circle'"
                    style="color: #008000; font-size: 1.2rem;"></i>
                    <span>Repeat Event</span>
                    @if (intervalTaskRepeat && intervalTaskRepeat.frequency!=0) {
                      <span
                        class="ml-auto" style="color: #008000; border: 1px solid #d1d5db; padding: 2px 8px; border-radius: 4px; font-size: 0.85rem;">
                        [On]
                      </span>
                    }
                  </div>
                </ng-template>
                <app-interval-select [taskId]="taskId"
                  [interval]="intervalTaskRepeat" intervalType="1">
                </app-interval-select>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>
        <div class="event-dialog-footer">
          <button pButton type="button" label="Close" class="p-button-text" (click)="closeEventDialog()"></button>
          <button pButton type="button" label="Save" (click)="saveEventDialog()"></button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Categories Dialog -->
  <ng-template #categoriesDialogTemplate>
    <div class="dialog-container categories-dialog">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div class="dialog-title">Categories</div>
        </div>
        <div>
          <button mat-button (click)="closeCategoriesDialog()">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="categories-container">
          <div class="category-item">
            <app-tag-dd-select [tagSource]="40" [tagSourceId]="taskId"
              tagType="1" (messageEvent)="setAssignedToTagId($event)">
            </app-tag-dd-select>
          </div>
          <div class="category-item">
            <app-tag-dd-select [tagSource]="40" [tagSourceId]="taskId"
              tagType="2"
            (messageEvent)="setAssignedToTagId($event)"></app-tag-dd-select>
          </div>
          <div class="category-item">
            <app-tag-dd-select [tagSource]="40" [tagSourceId]="taskId"
              tagType="3" (messageEvent)="setAssignedToTagId($event)">
            </app-tag-dd-select>
          </div>
          <div class="category-item">
            <app-tag-dd-select [tagSource]="40" [tagSourceId]="taskId"
              tagType="5"
            (messageEvent)="setAssignedToTagId($event)"></app-tag-dd-select>
          </div>
          <div class="category-item">
            <app-tag-dd-select [tagSource]="40" [tagSourceId]="taskId"
              tagType="6" (messageEvent)="setAssignedToTagId($event)">
            </app-tag-dd-select>
          </div>
          <div class="category-item">
            <app-tag-dd-select [tagSource]="40" [tagSourceId]="taskId"
              tagType="7"
            (messageEvent)="setAssignedToTagId($event)"></app-tag-dd-select>
          </div>
        </div>
      </mat-dialog-content>
      <!-- <mat-dialog-actions align="end">
      <button mat-button (click)="closeCategoriesDialog()">Close</button>
    </mat-dialog-actions> -->
  </div>
</ng-template>

<ng-template #tagsDialogTemplate>
  <div class="dialog-container tags-dialog">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div class="dialog-title">Tags</div>
      </div>
      <div>
        <button mat-button (click)="closeTagsDialog()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="tags-dialog-content">
        <app-tag-join-select
          [tagSource]="40"
          [tagSourceId]="taskId"
          [tags]="taskTagList"
          tagType="4"
          (messageEvent)="setAssignedToTagId($event)">
        </app-tag-join-select>
      </div>
    </mat-dialog-content>
  </div>
</ng-template>

<!-- Collaborators Dialog -->
<ng-template #collaboratorsDialogTemplate>
  <div class="dialog-container collaborators-dialog">
    <h2 mat-dialog-title>Collaborators</h2>
    <mat-dialog-content>
      <app-team-users-select [taskId]="taskId" [taskUsers]="taskUsers">
      </app-team-users-select>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="closeCollaboratorsDialog()">Close</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<!-- Contact Dialog -->
<ng-template #contactDialogTemplate>
  <div class="dialog-container contact-dialog">
    <h2 mat-dialog-title>Contact</h2>
    <mat-dialog-content>
      <app-user-contact [taskUserRole]="1" [taskId]="taskId" [taskUsers]="taskUsers" [formAction]="formAction"
        [expandAddFormOnCreate]="true" [expandAddFormOnEdit]="false" (messageEvent)="setAssignedToUserId($event)">
      </app-user-contact>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="closeContactDialog()">Close</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<!-- Files Dialog -->
<ng-template #filesDialogTemplate>
  <div class="dialog-container">
    <h2 mat-dialog-title>Files</h2>
    <mat-dialog-content>
      <app-document [taskId]="taskId" [taskDocuments]="taskDocuments">
      </app-document>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="closeFilesDialog()">Close</button>
    </mat-dialog-actions>
  </div>
</ng-template>
